{
  "Audio Player": "Lecteur audio",
  "Video Player": "Lecteur vidéo",
  "Play": "Démarrer",
  "Pause": "Pause",
  "Replay": "Redémarrer",
  "Current Time": "Temps écoulé",
  "Duration": "Durée",
  "Remaining Time": "Temps restant",
  "Stream Type": "Type de flux",
  "LIVE": "LIVE",
  "Loaded": "Chargé",
  "Progress": "Progression",
  "Progress Bar": "Barre de progression",
  "progress bar timing: currentTime={1} duration={2}": "{1} de {2}",
  "Fullscreen": "Plein écran",
  "Non-Fullscreen": "Fenêtré",
  "Mute": "Sourdine",
  "Unmute": "Son activé",
  "Playback Rate": "Vitesse de lecture",
  "Subtitles": "Sous-titres",
  "subtitles off": "Sous-titres désactivés",
  "Captions": "Sous-titres transcrits",
  "captions off": "Sous-titres transcrits désactivés",
  "Chapters": "Chapitres",
  "Descriptions": "Descriptions",
  "descriptions off": "descriptions désactivées",
  "Audio Track": "Piste audio",
  "Volume Level": "Niveau de volume",
  "You aborted the media playback": "Vous avez interrompu la lecture de la vidéo.",
  "A network error caused the media download to fail part-way.": "Une erreur de réseau a interrompu le téléchargement de la vidéo.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "Cette vidéo n'a pas pu être chargée, soit parce que le serveur ou le réseau a échoué ou parce que le format n'est pas reconnu.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "La lecture de la vidéo a été interrompue à cause d'un problème de corruption ou parce que la vidéo utilise des fonctionnalités non prises en charge par votre navigateur.",
  "No compatible source was found for this media.": "Aucune source compatible n'a été trouvée pour cette vidéo.",
  "The media is encrypted and we do not have the keys to decrypt it.": "Le média est chiffré et nous n'avons pas les clés pour le déchiffrer.",
  "Play Video": "Lire la vidéo",
  "Close": "Fermer",
  "Close Modal Dialog": "Fermer la boîte de dialogue modale",
  "Modal Window": "Fenêtre modale",
  "This is a modal window": "Ceci est une fenêtre modale",
  "This modal can be closed by pressing the Escape key or activating the close button.": "Ce modal peut être fermé en appuyant sur la touche Échap ou activer le bouton de fermeture.",
  ", opens captions settings dialog": ", ouvrir les paramètres des sous-titres transcrits",
  ", opens subtitles settings dialog": ", ouvrir les paramètres des sous-titres",
  ", opens descriptions settings dialog": ", ouvrir les paramètres des descriptions",
  ", selected": ", sélectionné",
  "captions settings": "Paramètres des sous-titres transcrits",
  "subtitles settings": "Paramètres des sous-titres",
  "descriptions settings": "Paramètres des descriptions",
  "Text": "Texte",
  "White": "Blanc",
  "Black": "Noir",
  "Red": "Rouge",
  "Green": "Vert",
  "Blue": "Bleu",
  "Yellow": "Jaune",
  "Magenta": "Magenta",
  "Cyan": "Cyan",
  "Background": "Arrière-plan",
  "Window": "Fenêtre",
  "Transparent": "Transparent",
  "Semi-Transparent": "Semi-transparent",
  "Opaque": "Opaque",
  "Font Size": "Taille des caractères",
  "Text Edge Style": "Style des contours du texte",
  "None": "Aucun",
  "Raised": "Élevé",
  "Depressed": "Enfoncé",
  "Uniform": "Uniforme",
  "Dropshadow": "Ombre portée",
  "Font Family": "Famille de polices",
  "Proportional Sans-Serif": "Polices sans empattement (Proportional Sans-Serif)",
  "Monospace Sans-Serif": "Polices sans empattement (Monospace Sans-Serif)",
  "Proportional Serif": "Polices avec empattement (Proportional Serif)",
  "Monospace Serif": "Polices avec empattement (Monospace Serif)",
  "Casual": "Manuscrite",
  "Script": "Scripte",
  "Small Caps": "Petites capitales",
  "Reset": "Réinitialiser",
  "restore all settings to the default values": "Restaurer tous les paramètres aux valeurs par défaut",
  "Done": "Terminé",
  "Caption Settings Dialog": "Boîte de dialogue des paramètres des sous-titres transcrits",
  "Beginning of dialog window. Escape will cancel and close the window.": "Début de la fenêtre de dialogue. La touche d'échappement annulera et fermera la fenêtre.",
  "End of dialog window.": "Fin de la fenêtre de dialogue.",
  "ISO-639-1": "fr",
  "10 seconds backward": "Reculer de 10 secondes",
  "30 seconds forward": "Avancer de 30 secondes",
  "Audio": "Audio",
  "Audio and subtitles": "Audio et sous-titres",
  "Audio Description": "Audio Description",
  "Auto play": "Lecture automatique",
  "Back": "Retour",
  "Casting to": "Ce contenu se joue sur",
  "Content will be available in {1} days": "Ce contenu sera disponible dans {1} jours",
  "Current position": "Position courante",
  "Current subject": "Sujet courant",
  "Days": "Jours",
  "Duration: {1}": "Durée: {1}",
  "Edit player settings": "Modifier les paramètres",
  "Episode": "Épisode",
  "HD": "HD",
  "Continuous Playback": "Lecture continue",
  "Cancel": "Annuler",
  "Coming next": "À suivre",
  "Copied": "Copié",
  "copy": "Copier",
  "Copy debug info": "Copier les infos de débogage",
  "Copy link": "Copier le lien",
  "Facebook": "Facebook",
  "Font size level {1}": "Taille de police niveau {1}",
  "Hours": "Heures",
  "Integrate": "Intégrer",
  "Issue:": "Problème rencontré :",
  "LinkedIn": "LinkedIn",
  "Mail": "E-mail",
  "Minutes": "Minutes",
  "Off": "Désactivé",
  "Open {1} in Play {2}": "Ouvrir {1} dans Play {2}",
  "Playback will begin shortly": "La lecture est sur le point de débuter",
  "Please indicate the problem below, so that we can help you:": "Merci de décrire votre problème afin que nous puissions vous aider :",
  "Quality": "Qualité",
  "Report a technical problem": "Signaler un problème technique",
  "SD": "SD",
  "Seconds": "Secondes",
  "Seek to live, currently behind live": "Revenir au direct",
  "Seek to live, currently playing live": "Direct en cours",
  "Send bug report": "Envoyer un rapport d'erreur",
  "Share at current position": "Partager la position courante",
  "Share by e-mail": "Partager par e-mail",
  "Share": "Partager",
  "Share on {1}": "Partager sur {1}",
  "Share on Facebook": "Partager sur Facebook",
  "Share on Linkedin": "Partager sur Linkedin",
  "Share on Twitter": "Partager sur Twitter",
  "Share on Whatsapp": "Partager sur Whatsapp",
  "Share on X": "Partager sur X",
  "Share the current subject": "Partager le sujet courant",
  "Share the episode": "Partager l'épisode",
  "Skip credits": "Passer",
  "Skip intro": "Passer l’intro",
  "Speed": "Vitesse de lecture",
  "Start casting": "Jouer sur Chromecast",
  "Start pip": "Démarrer l’image dans l’image",
  "Stop": "Stop",
  "Stop casting": "Arrêter Chromecast",
  "Stop pip": "Arrêter l’image dans l’image",
  "The content cannot be played.": "Ce contenu ne peut être joué.",
  "This content cannot be played while using a VPN.": "Ce contenu ne peut pas être lu lorsque vous utilisez un VPN.",
  "The content was skipped due to legal restriction": "Une séquence dépubliée sur décision de justice n’a pas été lue",
  "This content is temporarily unavailable for journalistic reasons.": "Ce contenu est temporairement indisponible pour des raisons éditoriales.",
  "This commercial media is not available.": "Ce contenu n’est actuellement pas disponible.",
  "This content is not available.": "Ce contenu n’est actuellement pas disponible.",
  "This content is not available anymore.": "Ce contenu n’est plus disponible.",
  "This content is not available due to legal restrictions.": "Pour des raisons juridiques, ce contenu n'est pas disponible.",
  "This content is not available outside Switzerland.": "La RTS ne dispose pas des droits de diffusion en dehors de la Suisse.",
  "This content is not yet available. Please try again later.": "Ce contenu n'est pas encore disponible. Veuillez réessayer plus tard.",
  "To protect children, this content is only available between 8PM and 6AM.": "Pour protéger les enfants, ce contenu est accessible entre 20h et 6h.",
  "To protect children, this content is only available between 11PM and 5AM.": "Pour protéger les enfants, ce contenu est accessible entre 23h et 5h.",
  "Twitter": "Twitter",
  "Unable to display the content. For more information and help, click here...": "Impossible d'afficher le contenu. Pour plus d'informations et obtenir de l'aide, cliquez ici...",
  "Unfortunately the 360 playback experience is not compatible with your browser version.": "Malheureusement, l'expérience 360 n'est pas compatible avec la version de votre navigateur.",
  "Unfortunately this format is not compatible with your browser.": "Malheureusement ce format n'est pas compatible avec votre navigateur.",
  "WhatsApp": "WhatsApp",
  "X": "X"
}
